import type { ISettingsServiceOptions } from '@inter-ikea-kompis/core/services'
import type { DexfSettingsFilterSegment } from '@inter-ikea-kompis/core/types'

import { ICF_VERSION } from '@/constants/icf'
import { getLocaleFromPath } from '@/utils/base-path-params'

const locale = getLocaleFromPath()
export const DEXF_API_KEY = '36d0ffe2-38b4-4706-afb3-c9630e9d6efb'
export const APP_ID = 'sofaplatform'

// Dexf has ZZ as a test locale, but Kompis uses XZ
const TRANSLATION_ENDPOINTS = [
  '/addon-app/translations/kompis/en-XZ.json',
  `/addon-app/translations/kompis/${locale === 'en-ZZ' ? 'en-XZ' : '{language}-{country}'}.json`,
  `/addon-app/sofas/platform/translations/${locale === 'en-ZZ' ? 'en-XZ' : '{language}-{country}'}.json`,
]

export function getDexfFilterSegment(): DexfSettingsFilterSegment {
  const mode = import.meta.env.MODE

  if (mode === 'development') {
    return 'development'
  }

  // CTE deployments
  if (mode === 'cte') {
    return 'verification'
  }
  return 'production'
}

type KompisServiceBaseSettings = {
  applicationName: string
  consumer: string
  contract: string
  filterSegment: DexfSettingsFilterSegment
  translationEndpoints: string[]
  dexfIcfVersion: string
} & ISettingsServiceOptions

export const KOMPIS_SERVICE_BASE_SETTINGS: KompisServiceBaseSettings = {
  applicationName: APP_ID,
  consumer: 'FIRST',
  contract: '36341',
  dexfApiKey: DEXF_API_KEY,
  dexfApplicationId: APP_ID,
  dexfEnvironment: 'production',
  filterSegment: getDexfFilterSegment(),
  locale,
  translationEndpoints: TRANSLATION_ENDPOINTS,
  dexfIcfVersion: ICF_VERSION,
}
